import './ErrorLogo.css';

export default function ErrorLogo(): JSX.Element {
  return (
    <div className="error-logo">
      <svg aria-hidden="true" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.6665 32.4997C2.6665 16.2993 15.7995 3.16632 31.9998 3.16632C48.2002 3.16632 61.3332 16.2993 61.3332 32.4997C61.3332 48.7 48.2002 61.833 31.9998 61.833C15.7995 61.833 2.6665 48.7 2.6665 32.4997ZM28.7855 21.1645C28.7205 19.3443 30.1785 17.8333 31.9998 17.8333C33.8212 17.8333 35.2792 19.3443 35.2142 21.1645L34.7617 33.835C34.7086 35.322 33.4877 36.5 31.9998 36.5C30.5119 36.5 29.2911 35.322 29.238 33.835L28.7855 21.1645ZM27.9998 43.1666C27.9998 40.9575 29.7907 39.1666 31.9998 39.1666C34.209 39.1666 35.9998 40.9575 35.9998 43.1666C35.9998 45.3758 34.209 47.1666 31.9998 47.1666C29.7907 47.1666 27.9998 45.3758 27.9998 43.1666Z"
          fill="#C60000"
        />
      </svg>
    </div>
  );
}
